var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("base-modal", {
    scopedSlots: _vm._u(
      [
        {
          key: "header",
          fn: function () {
            return [
              _c("div", { staticClass: "teacher-modal-header" }, [
                _c("span", { staticClass: "title" }, [
                  _vm._v(" " + _vm._s(_vm.title) + " "),
                ]),
                _vm._v(" "),
                _c("img", {
                  staticClass: "close-icon",
                  attrs: {
                    id: "coco-modal-header-close-button",
                    src: "/images/common/IconClose.svg",
                    "data-dismiss": _vm.backboneClose,
                  },
                  on: _vm._d({}, [
                    _vm.vueClose,
                    function ($event) {
                      return _vm.$emit("close")
                    },
                  ]),
                }),
              ]),
            ]
          },
          proxy: true,
        },
        {
          key: "body",
          fn: function () {
            return [_vm._t("default")]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }